var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"loading-container w-100 h-100 d-flex justify-content-center align-items-center"},[_c('b-spinner',{staticStyle:{"width":"4rem","height":"4rem"},attrs:{"variant":"primary","label":"Spinning"}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }